
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  display:flex;
  width:100%;
}

.se-counter{
  display:flex;
  flex-direction:column;
  background-color:var(--brand-secondary-4);
  width:100%;
  height:100%;
}

.se-counter--wrapper{
  display:flex;
  flex-direction:column;
  gap:1rem;
  height:100%;
}

@media (min-width: 768px){

.se-counter--wrapper{
    gap:1.5rem
}
  }

.se-counter--count{
  font-family:var(--ff-rift);
  color:var(--brand-primary-1);
  font-size:var(--fs-super-mobile);
  line-height:3.75rem;
}

@media (min-width: 1280px){

.se-counter--count{
    font-size:var(--fs-super)
}
  }

@media (min-width: 768px) and (max-width: 1280px){

.se-counter--count{
    font-size:var(--fs-h2)
}
  }

.se-counter--modifier{
  font-family:var(--ff-rift);
  color:var(--brand-primary-1);
  text-transform:lowercase !important;
  font-size:var(--fs-super-mobile);
  line-height:3.75rem;
}

@media (min-width: 1280px){

.se-counter--modifier{
    font-size:var(--fs-super)
}
  }

@media (min-width: 768px) and (max-width: 1280px){

.se-counter--modifier{
    font-size:var(--fs-h2)
}
  }

.se-counter--description{
  font-family:var(--ff-dmsans);
  font-size:var(--fs-lg-mobile);
  color:var(--gray-800);
}

@media (min-width: 1280px){

.se-counter--description{
    font-size:var(--fs-lg)
}
  }

@media (max-width: 767px){

.se-counter--description{
    font-size:var(--fs-base)
}
  }

slot[name='cta']{
  display:flex;
  margin-top:auto;
  font-size:var(--fs-base);
}

@media (min-width: 1280px){

slot[name='cta']{
    font-size:var(--fs-base)
}
  }
`;